import { render, staticRenderFns } from "./NewFillInTheBlank.vue?vue&type=template&id=8529d9fe&scoped=true&"
import script from "./NewFillInTheBlank.vue?vue&type=script&lang=js&"
export * from "./NewFillInTheBlank.vue?vue&type=script&lang=js&"
import style1 from "./NewFillInTheBlank.vue?vue&type=style&index=1&id=8529d9fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8529d9fe",
  null
  
)

export default component.exports